import { render, staticRenderFns } from "./describe_image.vue?vue&type=template&id=6472dcf5&scoped=true"
import script from "./describe_image.vue?vue&type=script&lang=js"
export * from "./describe_image.vue?vue&type=script&lang=js"
import style0 from "./describe_image.vue?vue&type=style&index=0&id=6472dcf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472dcf5",
  null
  
)

export default component.exports